import { render, staticRenderFns } from "./AulasInfo.vue?vue&type=template&id=f14e3484&scoped=true"
import script from "./AulasInfo.vue?vue&type=script&lang=js"
export * from "./AulasInfo.vue?vue&type=script&lang=js"
import style0 from "./AulasInfo.vue?vue&type=style&index=0&id=f14e3484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14e3484",
  null
  
)

export default component.exports